import { createQueryKeys } from "@lukemorales/query-key-factory";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { Brand } from "@models/Brand";
import client from "@services/api";

const brandsKeyFactory = createQueryKeys("brands", {
  list: {
    queryKey: null,
    queryFn: () => client.get<Brand[]>("brands").then((res) => res.data),
  },
});

export const useBrandsListQuery = () => {
  return useQuery({
    ...brandsKeyFactory.list,
    staleTime: Infinity,
  });
};

type CreateBrandPayload = {
  name: string;
};

export const useCreateBrandMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateBrandPayload) =>
      client
        .post<Brand>("brands", { __type: "brand", ...data })
        .then((res) => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: brandsKeyFactory.list.queryKey,
      });
    },
  });
};

type UpdateBrandPayload = {
  id: string;
  name: string;
};

export const useUpdateBrandMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, name }: UpdateBrandPayload) =>
      client
        .update<Brand>(`brands/${id}`, { __type: "brand", name })
        .then((res) => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: brandsKeyFactory.list.queryKey,
      });
    },
  });
};
